import { render } from "./AllRegistrations.vue?vue&type=template&id=1df21889&scoped=true"
import script from "./AllRegistrations.vue?vue&type=script&lang=js"
export * from "./AllRegistrations.vue?vue&type=script&lang=js"

import "./AllRegistrations.vue?vue&type=style&index=0&id=1df21889&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1df21889"]])

export default __exports__